import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaCatReq.mjs'

/**
 * 需求单固定节点
 * 需求模型B（RMB）总图（SA_MAP_KMB.ftl）使用
 *
 * 目前为纯固定占位节点：不承载数据、不允许挂载子节点
 * （平台无 CAT_REQ 类型的既有语义，后续按需求明确后再接入）
 */
export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,
    })
}
